import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import {
  getApiV1CourseregistrationEnrollmentGridChildrenQueryKey,
  getApiV1CourseregistrationEnrollmentGridQueryKey,
  usePutApiV1CourseregistrationEnrollmentPolo,
} from '@/shared/api/generated';

/**
 * Hook para atualizar o polo de uma matrícula.
 * Chama PUT /api/v1/courseregistration/enrollment/polo via query params e invalida o grid.
 *
 * @param onSuccess - Callback chamado após troca de polo bem-sucedida
 */
export function useChangePolo(onSuccess: () => void) {
  const queryClient = useQueryClient();

  const { mutate, isPending: isChanging } = usePutApiV1CourseregistrationEnrollmentPolo({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: getApiV1CourseregistrationEnrollmentGridQueryKey(),
        });
        void queryClient.invalidateQueries({
          queryKey: getApiV1CourseregistrationEnrollmentGridChildrenQueryKey(),
        });
        onSuccess();
      },
    },
  });

  const changePolo = useCallback(
    (data: { enrollmentId: number; newPoloId: string }) => {
      mutate({
        params: {
          courseRegistrationId: data.enrollmentId,
          poloId: Number(data.newPoloId),
        },
      });
    },
    [mutate],
  );

  return { changePolo, isChanging } as const;
}
